import { get, post, put, del } from "./http";
import { BaseUrlNew } from "./NewSiteUrl";
import { headerDemo } from "./editHeader";

// ++++++++++ oss直传 ++++++++++

// 【用户】后台登录
export const ApiLogin = params => post( BaseUrlNew + "/api/user/login",params, headerDemo, 1, '1.0');
// 【用户】发送登陆验证码
export const sendLoginCode = params => post( BaseUrlNew + "/api/account/sendLoginCode",params, headerDemo, 1, '4.0');
// 【用户】后台验证码登录
export const loginbycode = params => post( BaseUrlNew + "/api/user/loginbycode",params, headerDemo, 1, '1.0');
// 【用户】退出登录
export const loginout = params =>get( BaseUrlNew + "/api/user/loginout",params, 1, '1.0');

// 【菜单】获取用户菜单列表
export const asideMenu = (params, userId) =>get( BaseUrlNew + "/api/menu/getlist/"+userId,params, 1);
// 【菜单】获取用户某一页的按钮权限
export const buttongetlist = params =>get( BaseUrlNew + "/api/menu/button/getlist",params, 1, '1.0');
// 图片上传公共接口 --- 上传图片 & 多图 & 上传头像
export const UploadImgForServer = params =>post("/Upload/Upload/UploadImgForServer",params);
// 按层级获取省份城市区县列表
export const provincegetcountys = params => get(BaseUrlNew + '/api/area/province/getcountys', params, 1, '1.0');
// 获取基础数据-省市
export const oneGetProvinceAndCityList = params => post("/BaseDataNew/Province/GetProvinceAndCityList", params);
// oss直传 获取OSS上传参数以及路径
export const getOssFile = params =>get( BaseUrlNew + "/api/ossFile",params, 1, '4.0');
// 上传文件记录并返回id
export const postAddFile = params =>post( BaseUrlNew + "/api/ossFile/addFile",params, headerDemo, 1, '4.0');
// 上传视频
export const uploadVedio = (params, newId) =>post( BaseUrlNew + "/api/ossFile/uploadVideo?source=" + newId, params, headerDemo, 1, '1.0');
// oss直传 获取OSS上传参数以及路径
export const getUploadOSSOption = params =>get( BaseUrlNew + "/api/ossFile/appUploadOSSOption",params, 1, '1.0');
// 获取任务过滤范围集合
export const getfilterlist = params =>get( BaseUrlNew + "/api/task/config/getfilterlist",params, 1, '1.0');
// 商家联盟获取用户身份以及可查看的店铺
export const userIdentity = params =>get( BaseUrlNew + "/api/brandBusiness/userIdentity",params, 1);
// 根据后台登录员工id查询员工所属机构列表
export const getStaffBack = params =>get( BaseUrlNew + "/api/staff/back",params, 1, '2.0');
// 微信二维码下单（开启活动时调用）（新接口）
export const postPlaceOrderNative = params => post( BaseUrlNew + "/api/weChatServerPay/placeOrderNative",params, headerDemo, 1, '1.0');
// 获取数据字典集合-颜色主题
export const datadictionaryGetlist = params =>get( BaseUrlNew + "/api/datadictionary/getlist",params, 1, '1.0');
// (通用) 虚拟钱包支付接口
export const payment = (params,businessType,businessId) =>post(
    BaseUrlNew + "/api/vmtransaction/payment/" + businessType +'/'+ businessId,params, headerDemo, 1, '1.0');
// 商品品类
export const SelectBrandTypeBaseDataByCondition = params =>post("/bdService/BaseData/SelectBrandTypeBaseDataByCondition",params,'formdata');
// 用户可查看的企业
export const getenterprise = params =>get( BaseUrlNew + "/api/enterprise/userIdentity",params, 1, '1.0');
// OCR识别
export const toolsOcr = params => post( BaseUrlNew + "/api/tools/ocr",params, headerDemo, 1, '1.0');
// 修改后台用户手机号
export const changephone = params =>put( BaseUrlNew + "/api/tools/backuser/changephone",params, headerDemo, 1, '1.0');
// 发送短信验证码
export const toolsSendcode = params => post( BaseUrlNew + "/api/tools/sendcode",params, headerDemo, 1, '1.0');
// 验证短信验证码
export const toolsVerifycode = params => post( BaseUrlNew + "/api/tools/verifycode",params, headerDemo, 1, '1.0');


// ++++++++++ 商品管理 ++++++++++

// 单个商品推荐
export const getRecommendInfo = params =>get( BaseUrlNew + "/api/goods/recommendInfo",params, 1, '4.0');
// 多个商品推荐
export const postSetRecommend = params =>post( BaseUrlNew + "/api/goods/setRecommend",params, headerDemo, 1, '4.0');



// ++++++++++ 系统管理-功能配置 ++++++++++

// 客源大厅初始化配置
export const depositgetinfo = (params, businessId) => get(BaseUrlNew + "/api/clue/deposit/getinfo/" + businessId, params, 1, '1.0');
// 客源大厅初始化配置
export const switchgetinfo = (params, businessId) => get(BaseUrlNew + "/api/precisioncustomer/switch/getinfo/" + businessId, params,  1, '1.0');


// ++++++++++ 系统管理-精准客户配置 ++++++++++
//获取商品分类列表
export const goodstypegetlist = params => get(BaseUrlNew + "/api/auxiliary/goodstype/getlist", params, 1, '1.0');
//获取品牌类型列表
export const brandtypegetlist = params => get(BaseUrlNew + "/api/auxiliary/brandtype/getlist", params, 1, '1.0');
//获取品牌列表
export const brandgetlist = params => get(BaseUrlNew + "/api/auxiliary/brand/getlist", params, 1, '1.0');




// WEBPACK FOOTER //
// ./src/api/newOss.js